<template>
  <Row>
    <Col>
      <h4
        class="text-paragraph-1 font-weight-medium mr-2 mb-2"
        v-text="lc.title"
      />
      <p :class="grayText">{{ lc.description }}
        <span class="d-block">{{ lc.observation }}</span>
      </p>
    </Col>
  </Row>
</template>

<script>
import { Row, Col, useLocale } from '@locaweb/design-system-vue'

export default {
  name: 'FaviconSpecifications',
  components: {
    Row,
    Col
  },
  setup () {
    const lc = useLocale('site.favicon.faviconCard.faviconSpecifications')
    const grayText = 'gray--text text--scale500 text-paragraph-2'

    return { lc, grayText }
  }
}
</script>
